module.exports = __webpack_public_path__ + "static/media/sidebar__merchants.54cc1559.svg";